import '../styles/Detailed-weather-cards.css';

const DetailedWeatherCards = () => {
    return; 
};

export default DetailedWeatherCards; 